import { DataGridTheme } from './data-grid.types';

/**
 * Dark theme for the element grid.
 * Matches the application's default dark color palette.
 * This is the default appearance when no theme is passed.
 */
// TODO: When we implement the dark theme, we should use the same design tokens as the light theme.
// However, since we do not have a definied dark theme that would be consistent and use accross all components, we are using a hardcoded dark theme for now.
// The fallback incase these themes are not provided to the grid default to light theme, to be consistent with the all other components.
export const DATA_GRID_DARK_THEME: DataGridTheme = {
  surface: '#0f172a',
  surfaceContainer: '#1e293b',
  surfaceVariant: '#1e293b',
  onSurface: '#e2e8f0',
  onSurfaceVariant: '#94a3b8',
  primary: '#3b82f6',
  borderColor: '#334155',
  rowStripe: 'rgba(30, 41, 59, 0.35)',
  rowHover: 'rgba(59, 130, 246, 0.06)',
  headerDiscriminatorBg: '#1f2d46',
  headerHoverBg: '#212e40',
  chipBg: 'rgba(59, 130, 246, 0.15)',
  chipBgActive: 'rgba(59, 130, 246, 0.3)',
  chipColor: '#93c5fd',
  chipBorder: 'rgba(59, 130, 246, 0.3)',
  danger: '#f87171',
  checkboxOutline: '#cbd5e1'
};

/**
 * Light theme for the element grid.
 * References the shared-ui --d-color-* design tokens so the grid stays
 * in sync with the global palette automatically.
 */
export const DATA_GRID_LIGHT_THEME: DataGridTheme = {
  surface: 'var(--d-color-surface)',
  surfaceContainer: 'var(--d-color-accent-100)',
  surfaceVariant: 'var(--d-color-surface-variant)',
  onSurface: 'var(--d-color-text-primary)',
  onSurfaceVariant: 'var(--d-color-text-secondary)',
  primary: 'var(--d-color-primary-500)',
  borderColor: 'var(--d-color-border)',
  rowStripe: 'var(--d-color-surface-variant)',
  rowHover: 'color-mix(in srgb, var(--d-color-primary-500) 6%, transparent)',
  headerDiscriminatorBg: 'var(--d-color-primary-50)',
  headerHoverBg: 'var(--d-color-accent-200)',
  chipBg: 'var(--d-color-primary-50)',
  chipBgActive: 'var(--d-color-primary-100)',
  chipColor: 'var(--d-color-primary-700)',
  chipBorder: 'color-mix(in srgb, var(--d-color-primary-500) 30%, transparent)',
  danger: 'var(--d-color-warn-600)',
  checkboxOutline: 'var(--d-color-text-secondary)'
};
